import { DatePipe } from '@angular/common';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { GeocercasService } from './../../../../../../views/monitoreo/services/geocercas.service';
import { VehiculoGeocerca } from './../../../../../../_entities/geocerca/vehiculo-geocerca';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { finalize } from 'rxjs/operators';
import { MapaMarkerComponent } from '../../../mapa-marker/mapa-marker.component';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { IGNICIONES, ALERTAS } from './../../../../../../_entities/estados';
import { DxValidationGroupComponent } from 'devextreme-angular';
import { ToastrService } from 'ngx-toastr';
const EXCEL_EXTENSION = '.xlsx';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

@Component({
	selector: 'kt-dentro-geocerca-modal',
	templateUrl: './dentro-geocerca-modal.component.html',
	styleUrls: ['./dentro-geocerca-modal.component.scss']
})
export class DentroGeocercaModalComponent implements OnInit {
	@ViewChild('targetGroup', { static: false }) validationGroup: DxValidationGroupComponent

	public reporteDentroGeocerca: VehiculoGeocerca[] = []
	public fechaInicio;
	public fechaFin;
	public showFilterRow: boolean;
	public idVehiculo: number;
	public loadingVisible: boolean = false;



	constructor(private geocercasService: GeocercasService,
		private toastService: ToastrService,
		private dialog: MatDialog,
		private datepipe: DatePipe,
		private dialogRef: MatDialogRef<DentroGeocercaModalComponent>,
		@Inject(MAT_DIALOG_DATA) public vehiculo) {
		this.showFilterRow = true;
		this.orderHeaderFilter = this.orderHeaderFilter.bind(this);
	}


	ngOnInit() {
	}

	obtenerDentroGeocerca(fechaInicio, fechaFin) {
		if (this.validationGroup.instance.validate().isValid) {
			this.loadingVisible = true;
			const fechaInicial = this.datepipe.transform(fechaInicio, "yyyy-MM-dd");
			const fechaFinal = this.datepipe.transform(fechaFin, "yyyy-MM-dd");

			this.geocercasService.obtenerVehiculosDentroGeocerca(fechaInicial, fechaFinal).pipe(
				finalize(
					() => { this.loadingVisible = false; }
				)
			).subscribe(
				(vehiculos: VehiculoGeocerca[]) => {
					vehiculos.map(vehiculo => {

						const ignicion = IGNICIONES.find(ignicion => ignicion.id == vehiculo.ignicion);
						vehiculo.ignicion = ignicion.nombre;

						const estado = ALERTAS.find(alerta => alerta.id == vehiculo.estado);
						vehiculo.estado = estado.nombre;

						vehiculo.fecha = this.datepipe.transform(vehiculo.fecha, 'dd/MM/yyyy HH:mm');
					});

					this.reporteDentroGeocerca = vehiculos;
				}
			);
		} else {
			this.toastService.warning('Existen uno o mas campos vacios');
		}
	}

	public exportarExcel(json: any[], nombreArchivo: string): void {
		let hojaCalculo: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
		const libroTrabajo: XLSX.WorkBook = { Sheets: { 'data': hojaCalculo }, SheetNames: ['data'] };
		const excelBuffer: any = XLSX.write(libroTrabajo, { bookType: 'xlsx', type: 'array' });
		this.guardarExcel(excelBuffer, nombreArchivo);
	}

	private guardarExcel(buffer: any, nombreArchivo: string): void {
		const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
		FileSaver.saveAs(data, nombreArchivo + EXCEL_EXTENSION);
	}

	exportar() {
		let vehiculos = [];
		this.reporteDentroGeocerca.forEach(function (vehiculo) {
			let link = `http://www.gtmtec.mx/devsion/home/monitoreo/mapa?lat=${vehiculo.lat}&lng=${vehiculo.lng}`
			let vehiculoForm = {
				"Vehículo": {
					f: 'HYPERLINK("' + link + '",' + vehiculo.descripcion + ')',
					t: 'n',
					v: link
				},
				'Placas': vehiculo.placas,
				'Estado': vehiculo.estado,
				'Ignición': vehiculo.ignicion,
				'Fecha Y Hora': vehiculo.fecha
			}
			vehiculos.push(vehiculoForm);
		});

		this.exportarExcel(vehiculos, 'Vehiculos_Dentro_Geocerca');

	}


	ubicarPunto(data) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.width = "50%";
		dialogConfig.height = "60%"
		dialogConfig.data = data;
		dialogConfig.panelClass = 'custom-modalbox';
		this.dialogRef.close();
		this.dialog.open(MapaMarkerComponent, dialogConfig);
	}

	orderHeaderFilter(data) {
		data.dataSource.postProcess = (results) => {
			results.push({
				text: "Weekends",
				value: "weekends"
			});
			return results;
		};
	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}
}


